import React, { FC } from 'react';
import CourseLevelIcon from 'src/assets/icons/CourseLevelIcon';
import { courseLevels } from 'src/common/models/course';
import { courseListingActions } from 'src/state/courseListing/courseListingActions';
import { useDispatch, useSelector } from 'react-redux';
import { courseListingSelectedLevelsSelector } from 'src/state/courseListing/courseListingSelectors';
import { StyleProps } from 'src/lib/styleProps';
import {
  CourseListingFilter,
  CourseListingFilterCheckbox,
  CourseListingFilterItem,
  CourseListingFilterList,
  CourseListingFilterTitle,
} from 'src/public/components/course-listing/CourseListingFilter';

export const CourseListingCourseLevelFilter: FC<StyleProps> = ({ className, style }) => {
  const dispatch = useDispatch();
  const selectedLevels = useSelector(courseListingSelectedLevelsSelector);

  return (
    <CourseListingFilter className={className} style={style}>
      <CourseListingFilterTitle>
        <CourseLevelIcon size={18} />
        Poziom trudności
      </CourseListingFilterTitle>

      <CourseListingFilterList>
        {courseLevels.map((level) => (
          <CourseListingFilterItem active={selectedLevels[level.id]} key={level.id}>
            <CourseListingFilterCheckbox
              label={level.label}
              onChange={() => dispatch(courseListingActions.toggleLevel(level.id))}
              value={selectedLevels[level.id]}
            />
          </CourseListingFilterItem>
        ))}
      </CourseListingFilterList>
    </CourseListingFilter>
  );
};
